(function() {

    angular
      .module('meanApp')
      .factory('searchModal', ['$uibModal',
    function ($uibModal) {
        this.modalInstance = null;
        return {
        /**Will open the register or login function according to controller**/
            open : function(isLogin) {
                this.modalInstance = $uibModal.open({
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'common/factories/search.modal.view.html',
                    controller: 'intermediateSearchCtrl',
                    controllerAs: 'vm',
                    windowClass: 'intermediate-search-modal'
                });
            },
            get : function() {
                return this.modalInstance;
            }
        };
    }]);  
})();